<template>
  <div>
    <div class="mb-2">
      <va-input
        v-model="promocodeInfoData.code"
        class="mb-0"
        placeholder="Промокод"
      />
      <div
        v-if="
          !$v.promocodeInfoData.code.required &&
          $v.promocodeInfoData.code.$error
        "
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-2">
      <va-input
        v-model="promocodeInfoData.discount"
        class="mb-0"
        type="number"
        placeholder="Cкидка"
        @keypress="isNumber($event)"
      />
      <div
        v-if="
          !$v.promocodeInfoData.discount.required &&
          $v.promocodeInfoData.discount.$error
        "
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-2">
      <va-input
        disabled
        class="mb-0"
        :value="String(promocodeInfoData.expires_at)"
        placeholder="Срок действия промокода"
      />
      <div
        v-if="
          !$v.promocodeInfoData.expires_at.required &&
          $v.promocodeInfoData.expires_at.$error
        "
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mt-2">
      <date-picker
        v-model="promocodeInfoData.expires_at"
        is-required
        mode="date"
        :model-config="modelConfig"
        :min-date="new Date()"
      />
    </div>
    <div class="mt-4 text-center">
      <va-button @click="$emit('close')">Отменить</va-button>
      <va-button color="info" @click="submitHandler">Сохранить</va-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import api from '@/api/axios';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { DatePicker } from 'v-calendar';
import { required } from 'vuelidate/lib/validators';
dayjs.extend(isSameOrBefore);
Vue.component('date-picker', DatePicker);
export default {
  name: 'PromocodeCreate',
  props: {
    promocodeInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      promocodeInfoData: {
        ...this.promocodeInfo,
        expires_at: this.promocodeInfo.expires_at
          .split('-')
          .reverse()
          .join('-'),
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
    };
  },
  created() {
    const currDate = dayjs().format('YYYY-MM-DD');
    if (dayjs(this.promocodeInfoData.expires_at).isBefore(dayjs(currDate))) {
      this.promocodeInfoData.expires_at = currDate;
    }
  },
  validations: {
    promocodeInfoData: {
      code: {
        required,
      },
      discount: {
        required,
      },
      expires_at: {
        required,
      },
    },
  },
  methods: {
    async submitHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        // eslint-disable-next-line camelcase
        const { id, code, expires_at, discount } = this.promocodeInfoData;
        const requiredData = {
          code,
          discount: Number(discount),
          expires_at,
        };
        try {
          await api.put(`/admin/promocodes/${id}`, requiredData);
          this.$emit('needFetchPromocodes');
          this.$emit('close');
        } catch (error) {
          const discountError = error.response.data.errors.discount;
          if (discountError) {
            alert('Скидка не может быть больше 100');
          } else {
            return error;
          }
        }
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
